// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"d5b2869f","864":"0d8b8f38"}[chunkId] + ".chunk.js";
};